import { render, staticRenderFns } from "./couponConfig.vue?vue&type=template&id=5731a7b8&"
import script from "./couponConfig.vue?vue&type=script&lang=js&"
export * from "./couponConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5731a7b8')) {
      api.createRecord('5731a7b8', component.options)
    } else {
      api.reload('5731a7b8', component.options)
    }
    module.hot.accept("./couponConfig.vue?vue&type=template&id=5731a7b8&", function () {
      api.rerender('5731a7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/couponConfig.vue"
export default component.exports